import { PropsWithChildren, useState } from 'react';

import { ExclamationMarkImg } from '@/assets';
import * as HoverCard from '@radix-ui/react-hover-card';

function AllStakeTips({
  children,
  trigger,
}: PropsWithChildren & {
  trigger?: JSX.Element;
}) {
  const [open, setOpen] = useState(false);

  return (
    <HoverCard.Root openDelay={0} closeDelay={0} onOpenChange={setOpen} open={open}>
      <HoverCard.Trigger asChild>
        {trigger ?? (
          <img
            className="flex cursor-pointer"
            src={ExclamationMarkImg}
            width={16}
            height={16}
            onClick={(ev) => {
              ev.stopPropagation();
              setOpen((prev) => !prev);
            }}
          />
        )}
      </HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content align="end" alignOffset={-15} sideOffset={15}>
          <div className="border border-[#1F242F] bg-[#0C111D] rounded-md p-3 text-sm max-w-[300px]">
            {children}
          </div>
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
}

export default AllStakeTips;
